<div class="widget-container" #clusterStaticBarChart>
    <app-cluster-static-bar-chart 
        style="width: 100%;" 
        [config]="config" 
        [headerConfig]="this.item.config.widget_header_config"
        [heading]="heading" 
        [data]="data" 
        [item]="item" 
        [pageKey]="pageKey"
        [error_name]="error_name"
        >
</app-cluster-static-bar-chart>
</div>